import * as tslib_1 from "tslib";
import { ReverseRelevanceControl } from "../../../../../../form/src/common/controls/reverse-relevance-control";
import { ReverseQueryService } from "../../../../../../form/src/common/services";
import { Component } from "vue-property-decorator";
let ReverseRelevanceList = class ReverseRelevanceList extends ReverseRelevanceControl {
    constructor() {
        super(...arguments);
        this.data = [];
    }
    onClick(item) {
        this.open(item);
    }
    mounted() {
        const schemaCode = this.controlOpts.schemaCode || '';
        const listCode = this.controlOpts.listCode || '';
        const conditions = this.controlOpts.conditions;
        const formControls = this.getFormControls();
        const c = this.control;
        const param = ReverseQueryService.getParams(conditions, formControls, c, this.findController);
        const queryParam = [];
        if (param.length > 0) {
            ReverseQueryService.getListQueryConditions(schemaCode, listCode, param).then(res => {
                const queryConditions = res.conditions || [];
                param.forEach(p => {
                    const queryItem = queryConditions.find(q => q.propertyCode === p.code);
                    queryParam.push({
                        code: p.code,
                        type: queryItem.propertyType,
                        value: p.value
                    });
                });
                this.getAll(queryParam).then(data => (this.data = data));
            });
        }
        else {
            this.getAll(queryParam).then(data => (this.data = data));
        }
        // this.getAll().then(data => (this.data = data));
    }
};
ReverseRelevanceList = tslib_1.__decorate([
    Component({
        name: "reverse-relevance-list",
        components: {}
    })
], ReverseRelevanceList);
export default ReverseRelevanceList;
